import { Component } from 'react';
import LogRocket from 'logrocket';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '16px',
  minHeight: '100vh',
  padding: '24px',
  textAlign: 'center',
  fontFamily: 'Helvetica, Arial, sans-serif',
};

const buttonStyle = {
  padding: '12px 32px',
  border: 'none',
  borderRadius: '24px',
  backgroundColor: '#000',
  color: '#fff',
  fontSize: '16px',
  fontWeight: 700,
  cursor: 'pointer',
};

// The app previously had no error boundary at all: any uncaught render error
// (e.g. a chunk that failed to load, or an object rendered as a React child)
// unmounted the whole tree and stranded users on a dead page with no way out
// except manually reloading. This is the last-resort recovery surface; it
// deliberately avoids app providers/router/SCSS so it can never be taken down
// by the same failure it is reporting.
class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // React swallows boundary-caught errors (no window.onerror), so report
    // explicitly. captureException is a safe no-op when LogRocket didn't init.
    LogRocket.captureException(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (!hasError) {
      return children;
    }

    return (
      <div style={containerStyle}>
        <h1 style={{ fontSize: '24px', margin: 0 }}>Something went wrong</h1>
        <p style={{ fontSize: '16px', margin: 0 }}>
          Please reload the page to continue.
        </p>
        <button
          type="button"
          style={buttonStyle}
          onClick={() => window.location.reload()}
        >
          RELOAD
        </button>
      </div>
    );
  }
}

export default AppErrorBoundary;
